import actionTypes from '../../action-types'

export default () => ({
  type: actionTypes.AUTHENTICATION.REQUEST_TRANSFER_TOKEN,
})
